import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../AuthContext.jsx'
import { trackEvent } from '../analytics.js'

export default function AuthCallback() {
  const [searchParams] = useSearchParams()
  const { login } = useAuth()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [error, setError] = useState('')
  const calledRef = useRef(false)

  useEffect(() => {
    if (calledRef.current) return
    calledRef.current = true

    const code = searchParams.get('code')
    if (!code) {
      setError('auth.noCode')
      return
    }

    async function exchange() {
      try {
        const pendingRef = sessionStorage.getItem('pending_ref')
        const pendingInvite = sessionStorage.getItem('pending_invite')
        sessionStorage.removeItem('pending_ref')
        sessionStorage.removeItem('pending_invite')
        await login(code, { ref: pendingRef, invite: pendingInvite })
        const isNew = !localStorage.getItem('growlab_known_user')
        if (isNew) {
          localStorage.setItem('growlab_known_user', '1')
          trackEvent('sign_up', { method: 'google' })
        } else {
          trackEvent('login', { method: 'google' })
        }
        navigate('/chat', { replace: true })
      } catch {
        setError('auth.failed')
      }
    }

    exchange()
  }, [])

  if (error) {
    return (
      <div className="page-centered">
        <div className="login-card">
          <p className="login-error">{t(error)}</p>
          <Link to="/" className="login-legal-link">{t('auth.backToLogin')}</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="page-centered">
      <div className="login-card">
        <p style={{ color: '#aaa', textAlign: 'center' }}>{t('auth.signingIn')}</p>
      </div>
    </div>
  )
}
